import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  font-family: 'Montserrat', sans-serif;
  background-color: transparent;

  .container {
    display: flex;
    flex: 1;
    border-radius: 17px;
    box-shadow: ${(props) =>
      props.theme.name === 'light'
        ? '0 4px 16px rgba(0, 0, 0, 0.08)'
        : '0 4px 12px rgba(0, 0, 0, 0.3)'};
    background: ${(props) =>
      props.theme.name === 'light' ? '#ffffff' : '#002b80'};
    border: ${(props) =>
      props.theme.name === 'light' ? '1px solid #cbd5e1' : 'none'};
    overflow: hidden;
  }
`

export const Header = styled.div`
  min-height: 50px;
  flex-shrink: 0;
  width: 100%;
  height: 50px;
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 17px 17px 0 0;
  justify-content: center;
  padding: 0 20px;
  background: ${(props) =>
    props.theme.name === 'light'
      ? '#f8fafc'
      : 'linear-gradient(to right, #001842ff, #00205b, #002b80)'};
  color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')};
  border-bottom: ${(props) =>
    props.theme.name === 'light' ? '1px solid #e2e8f0' : 'none'};
  font-size: 12px;
  font-weight: 600;
  z-index: 10000;
`

export const LeftContent = styled.div`
  flex: 1.2;
  background-color: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : '#002b80'};
  border-radius: 0 17px 17px 0;
  position: relative;
  padding: 20px;
  height: 100%;
  border-left: 1px solid
    ${(props) =>
      props.theme.name === 'light'
        ? '#e2e8f0'
        : 'rgba(255, 255, 255, 0.1)'};
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  color: ${(props) =>
    props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};

  h4 {
    margin-bottom: 5px;
    margin-top: 10px;
    color: ${(props) =>
      props.theme.name === 'light' ? '#001f5c' : '#f8fafc'};
  }

  hr {
    border-color: ${(props) =>
      props.theme.name === 'light'
        ? '#e2e8f0'
        : 'rgba(255, 255, 255, 0.1)'};
  }

  /* Custom Scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  select {
    height: 30px;
    border-radius: 5px;
    padding: 5px;
    border: 1px solid
      ${(props) =>
        props.theme.name === 'light' ? '#cbd5e1' : '#ccc'};
    background-color: ${(props) =>
      props.theme.name === 'light' ? '#ffffff' : '#001842'};
    color: ${(props) =>
      props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
  }
`

export const ButtonClose = styled.button`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: ${(props) =>
    props.theme.name === 'light' ? '#0284c7' : 'rgb(0, 43, 128)'};
  border: none;
  cursor: pointer;
  position: absolute;
  right: 20px;
  bottom: -10px;
  color: white;
`
export const Right = styled.div`
  flex: 5;
  overflow: hidden;
  background-color: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : '#002b80'};
  position: relative;
  border-radius: 17px 0 0 17px;
  height: 100%;

  /* Handsontable theme adaptativo */
  .ht-theme-main {
    --ht-color-bg: ${(props) =>
      props.theme.name === 'light' ? '#ffffff' : '#002b80'};
    --ht-color-text: ${(props) =>
      props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
    --ht-color-border: ${(props) =>
      props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.1)'};
    --ht-color-header-bg: ${(props) =>
      props.theme.name === 'light' ? '#f8fafc' : '#001842'};
    --ht-color-header-text: ${(props) =>
      props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
    --ht-color-header-border: ${(props) =>
      props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)'};
    --ht-color-row-hover-bg: ${(props) =>
      props.theme.name === 'light' ? '#f1f5f9' : '#003899'};
  }
`
export const Button = styled.button`
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  border-radius: 6px;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 800;
  font-family: 'Montserrat', sans-serif;
`

export const DateInput = styled.input`
  width: 100%;
  min-height: 50px;
  border-radius: 20px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)'};
  padding: 0 15px;
  font-family: 'Montserrat', sans-serif;
  color: ${(props) =>
    props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
  background-color: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : '#001842'};
  margin-bottom: 10px;
  color-scheme: ${(props) => (props.theme.name === 'light' ? 'light' : 'dark')};

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 1px #3b82f6;
  }
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  display: block;
  color: ${(props) =>
    props.theme.name === 'light' ? '#475569' : 'rgba(255, 255, 255, 0.5)'};
`

export const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-left-color: #3b82f6;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
